import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxDepressSettingsData {
  alerts?: boolean;
  alertLowMood?: boolean;
  alertGADScore?: boolean;
  thresholds?: {
    phq?: number;
    gad?: number;
  };
}

const DefaultSettings: EpxDepressSettingsData = {
  alerts: true,
  alertLowMood: true,
  alertGADScore: false,
  thresholds: {
    phq: 15,
    gad: 10
  }
};

interface EpxDepressSettingsProps {
  setForm?: (form: FormInstance<EpxDepressSettingsData>) => void;
  onSubmit?: (data: EpxDepressSettingsData) => void;
  disabled?: boolean;
}

const EpxDepressSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxDepressSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxDepressSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxDepressSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxDepressSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Alert for Low Mood (0-1)"
                name="alertLowMood"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="PHQ-9 Alert Threshold"
                name="thresholds.phq"
                min={1}
                max={27}
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Alert for GAD-7 Score"
                name="alertGADScore"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="GAD-7 Alert Threshold"
                name="thresholds.gad"
                min={1}
                max={21}
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxDepressSettings;
